<script setup lang="ts">
import {endpoints} from "~/constants/endpoints";
import ContactUs from '~/components/custom-ui/ContactUs.vue'

definePageMeta({
    name: 'faq_category'
})

useHead(
    {
      title: 'Help & Support'
    }
)

const route = useRoute();
const {data: baseGroup} = useAsyncData(`faq_group_${route.params.id}`,
    () => fetchData(endpoints.faq.singleGroup(route.params.id), {
        method: 'GET',
    }).then(({data, meta}) => data)
)
const {data: articlesList} = useAsyncData(`faq_group_${route.params.id}_articles`,
    () => fetchData(endpoints.faq.articles, {
        method: 'GET',
    }).then(({data, meta}) => data)
)
</script>

<template>
    <div class="container mx-auto px-4 my-10">
        <div class="grid place-items-center items-center mx-3">
            <div class="ys-home-card grid place-items-center my-10 w-full">
                <p v-if="baseGroup.title" class="ys-help-title-text" style="width: 510px">{{ baseGroup.title }}</p>
                <p v-if="baseGroup.description" class="text-center" style="width: 510px">{{ baseGroup.description }}</p>
                <NuxtImg src="SupportPage/books.png" width="166" height="84" />
            </div>
            <div class="grid grid-cols-2 gap-8">
                <NuxtLink v-for="item in articlesList"
                           :to="{name: 'faq_article', params: {article: item.documentId} }"
                           class="ys-support-theme-box flex items-center justify-between">
                    <p v-if="item.title" class="ys-text">{{ item.title }}</p>
                    <div class="icon-container">
                        <Icon size="24" name="ri:arrow-right-s-line"/>
                    </div>
                </NuxtLink>
            </div>
        </div>
        <ContactUs/>
    </div>
</template>


<style scoped lang="scss">

.ys-about-card-end {
  border-radius: 36px;
  background: rgba(247, 254, 248, 1);
}

.icon-container {
  width: 40px;
  height: 40px;
  padding: 6px 8px 6px 8px;
  gap: 10px;
  border-radius: 96px;
  border: 1px solid rgba(226, 228, 233, 1);
}

.ys-support-theme-box {
  padding: 16px 32px 16px 32px;
  gap: 30px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(226, 228, 233, 1);

}


.ys-home-card {
  border-radius: 36px;
  background: rgba(247, 254, 248, 1);
  padding: 32px;
  gap: 30px;
}

.ys-help-title-text {
  font-family: Involve, sans-serif;
  color: rgba(0, 0, 0, 1);
  font-size: 34px;
  font-weight: 400;
  line-height: 45px;
  text-align: center;
}

.ys-help-custom-title-text {
  font-family: Involve, sans-serif;
  font-style: italic;
  color: rgba(58, 62, 89, 1);
  font-size: 34px;
  font-weight: 500;
  line-height: 45px;
  text-align: left;
}


.ys-text {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: rgba(0, 0, 0, 1);
}

.ys-text-custom {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: rgba(0, 0, 0, 1);
}

</style>